import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { useNavigate } from "react-router-dom";

// initial state
export const initialState = {
  loading: false,
  loadingDashboardItems: false,
  error: null,
  dashboardDetails: [],
  searchResults: [],
  showPopup: false,
};

// our slice
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    setdashboardDetails: (state, { payload }) => {
      state.loading = false;
      state.dashboardDetails = payload;
      state.error = null;
    },
    setSearchResults: (state, { payload }) => {
      state.loading = false;
      state.searchResults = payload;
      state.error = null;
    },
    setShowPopup: (state, {payload}) => {
      state.showPopup = payload;
    }
  },
});
// export the actions
export const { setLoading, setdashboardDetails, setError, setSearchResults, setShowPopup } =
  dashboardSlice.actions;

// export the default reducer
export default dashboardSlice.reducer;

// export the selector for fetching the global state
export const dashboardSelector = (state) => state.dashboard;

export const GetdashboardDetails = (firmID, language) => async (dispatch) => {
  try {
    dispatch(setLoading());
    var req = {
      FirmID: firmID,
      Language: language,
    };
    let result = await http.post("Order/GetDashboardDetails", req);
    if (result.data.responseCode == 0) {
      dispatch(setdashboardDetails(result.data.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const CheckValidOrderForUser =
  (firmID, userId, orderNo, { toast }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      var req = {
        FirmID: firmID,
        userID: userId,
        fileNumber: orderNo,
      };
      let result = await http.post("Order/CheckValidOrderForUser", req);
      if (result.data.responseCode == 0) {
        dispatch(setSearchResults(result.data.responseObject));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
